import {SystemStatus} from '../../../core/enum';
import {GetIncidentHistoryDTO, SystemEntity, SubscribeEmailNotificationDTO} from '../Entity';
import {RemoteRepository} from './Repository';

export class RemoteRepositoryMock implements RemoteRepository {
  public GetIncidentHistory(payload: GetIncidentHistoryDTO): Promise<SystemEntity[]> {
    return Promise.resolve(
      [
        new Date('2022/03/03'),
        new Date('2022/03/02'),
        new Date('2022/03/01'),
        new Date('2022/02/22'),
        new Date('2022/02/20'),
        new Date('2022/02/18'),
        new Date('2022/02/15'),
        new Date('2022/02/04'),
        new Date('2022/02/01'),
      ].map((val, i) => {
        return {
          createdAt: val,
          id: '00000000-0000-0000-0000-000000000000',
          notes:
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Error dolores reiciendis, laborum perferendis est sint architecto accusantium quod quis quam aperiam, minima maiores molestiae maxime adipisci sequi? Pariatur, quisquam sint?',
          parentId: null,
          service: `Service Mock ${i + 1}`,
          status: SystemStatus.Degraded,
        };
      })
    );
  }

  public GetStatus(): Promise<SystemEntity[]> {
    return Promise.resolve([
      {
        id: '4102b3c9-ef6e-4674-b3fa-59e38fff8ec9',
        service: 'Otp',
        parentId: null,
        status: SystemStatus.Operational,
        notes: 'asdasdasdasd',
        createdAt: new Date('2022/02/01'),
        children: [
          {
            id: 'e9f9314e-9403-499a-a81c-91938c603065',
            service: 'otps',
            parentId: '4102b3c9-ef6e-4674-b3fa-59e38fff8ec9',
            status: SystemStatus.Maintenance,
            notes: 'asdasdasdasd',
            createdAt: new Date('2022/02/01'),
            children: [
              {
                id: '76d4ebd6-67a0-41f4-82c0-49c43278dab2',
                service: 'otps child',
                parentId: 'e9f9314e-9403-499a-a81c-91938c603065',
                status: SystemStatus.PartialOutage,
                notes: 'asdasdasdasd',
                createdAt: new Date('2022/02/01'),
                children: [],
              },
              {
                id: '76d4ebd6-67a0-41f4-82c0-49c43278dab2',
                service: 'otps child2',
                parentId: 'e9f9314e-9403-499a-a81c-91938c603065',
                status: SystemStatus.PartialOutage,
                notes: 'asdasdasdasd',
                createdAt: new Date('2022/02/01'),
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: '76d4ebd6-67a0-41f4-82c0-49c43278dab2',
        service: 'otp2',
        parentId: null,
        status: SystemStatus.PartialOutage,
        notes: 'asdasdasdasd',
        createdAt: new Date('2022/02/01'),
        children: [],
      },
      {
        id: '76d4ebd6-67a0-41f4-82c0-49c43278dab2',
        service: 'otp3',
        parentId: null,
        status: SystemStatus.PartialOutage,
        notes: 'asdasdasdasd',
        createdAt: new Date('2022/02/01'),
        children: [],
      },
      {
        id: '76d4ebd6-67a0-41f4-82c0-49c43278dab2',
        service: 'otp4',
        parentId: null,
        status: SystemStatus.PartialOutage,
        notes: 'asdasdasdasd',
        createdAt: new Date('2022/02/01'),
        children: [],
      },
    ]);
  }

  public SubscribeEmailNotificationCallback(
    payload: SubscribeEmailNotificationDTO
  ): Promise<boolean> {
    return Promise.resolve(true);
  }
  public SubscribeEmailNotification(payload: SubscribeEmailNotificationDTO): Promise<boolean> {
    return Promise.resolve(true);
  }

  public UnsubscribeEmailNotificationCallback(payload: string): Promise<boolean> {
    return Promise.resolve(true);
  }
}
